import type { BrandsCuratedVariant } from './brands-utils';

/** Page Designer region for content below Affordable Brands links. */
export const AFFORDABLE_BRANDS_SUBMENU_REGION_ID = 'affordableBrandsSubmenu';

/** Page Designer region for content below Bestselling Brands links. */
export const BESTSELLING_BRANDS_SUBMENU_REGION_ID = 'bestsellingBrandsSubmenu';

/** Page Designer region for content below New to Space NK links. */
export const NEW_TO_SPACE_NK_SUBMENU_REGION_ID = 'newToSpaceNkSubmenu';

export const BRANDS_SUBMENU_REGION_BY_VARIANT: Record<BrandsCuratedVariant, string> = {
    affordable: AFFORDABLE_BRANDS_SUBMENU_REGION_ID,
    bestselling: BESTSELLING_BRANDS_SUBMENU_REGION_ID,
    new: NEW_TO_SPACE_NK_SUBMENU_REGION_ID,
};

export function getBrandsSubmenuRegionId(variant: BrandsCuratedVariant): string {
    return BRANDS_SUBMENU_REGION_BY_VARIANT[variant];
}
